import LogoComponent from "../components/LogoComponent/LogoComponent.jsx";
import {
    LoginBoxStyled,
    LoginStyled,
    LoginWrapperHeaderStyled,
    LoginWrapperStyled
} from "../modules/Login/components/styled/LoginStyled.js";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { logAction } from "./appActions.js";
import { useSetBodyBackgroundColor } from "../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { useResponsive } from "../components/responsive";
import PageErrorContent from "./PageErrorContent";

function PageError({
   children,
   headerPanelComponent,
   ...pageErrorContentProps
}) {
    const {isSmallMaxWidth} = useResponsive();
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', isSmallMaxWidth);

    return <LoginWrapperStyled>
        <LoginWrapperHeaderStyled>
            <LogoComponent/>
            {!!headerPanelComponent && headerPanelComponent}
        </LoginWrapperHeaderStyled>
        <LoginStyled>
            <LoginBoxStyled className="d-flex flex-column align-items-center">
                <PageErrorContent {...pageErrorContentProps}>
                    {children}
                </PageErrorContent>
            </LoginBoxStyled>
        </LoginStyled>
    </LoginWrapperStyled>
}


const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => ({
    logAction: payload => dispatch(logAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageError);
